export const getDetailLineErrorMessage = (errorMessages) => {
    if (!Array.isArray(errorMessages)) return errorMessages;

    return errorMessages.map((error) => {
        if (error === null || typeof error !== 'object') return { description: String(error) };
        return {
            description: [error?.description, error?.line].filter(Boolean).join('; '),
        };
    });
};
